/*
 *
 * SalesforceVerify constants
 *
 */

import { defineApiActionTypes } from 'utils/action-helper';
const prefix = 'ui/containers/SalesforceVerify';

/*
 * @dev defineApiActionTypes a function that
 * return concat base with START,SUCCESS,FAILURE
 */
export const VERIFY_SALESFORCE = defineApiActionTypes(`${prefix}/VERIFY_SALESFORCE_START`);
